/**
 * Routine List
 * Mini list displayed on routines page
 */
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { ListItem } from '@components/ListItem';

import { ListTitle, OuterDiv } from './List.style';

type TListItem = { title?: string; subtitle?: string; child: React.ReactNode };

const RoutineList: React.FC<{
  listItems: TListItem[];
  title?: string;
  titleColor?: string;
  titleTransparent?: boolean;
}> = ({ listItems = [], title = '', titleColor, titleTransparent = false }) => {
  const { palette } = useTheme();
  const resolvedTitleColor = titleColor ?? palette.common.accentWhite;

  return (
    <OuterDiv titleTransparent={titleTransparent}>
      {title ? (
        <ListTitle
          titleColor={resolvedTitleColor}
          titleTransparent={titleTransparent}
        >
          {title}
        </ListTitle>
      ) : null}

      {listItems.map(({ title, subtitle, child }, index) => (
        <ListItem
          key={`listItem +${index}`}
          subtitle={subtitle}
          subtitleColor={palette.text.primary}
          title={title}
          titleColor={palette.text.secondary}
        >
          {child}
        </ListItem>
      ))}
    </OuterDiv>
  );
};

export default RoutineList;
